const name = "g-galleria";
export default {
  name,

  components: {},

  props: {
    corSetas: {
        type: String,
        default: 'gray'
    },
    TempoIntervalo: {
      type: Number,
      default: 2000
    },
    TrocaAutomatica: {
      type: Boolean,
      default: false
    },
    itemInicial: {
        type: Number,
        default: 0
    },
    mostrarItensNavegadores: {
        type: Boolean,
        default: true,    
    },
    mostrarIndicadores: {
        type: Boolean,
        default: true
    },
    ImgRotativa: {
        type: Boolean,
        default: true
    },
    valor: {
        type: Object,
        default: null
    },
    mostrarThumbnails: {
        type: Boolean,
        default: false
    },
    fullScreen: {
      type: Boolean,
      default: true
    },
    activeIndex :{
      type: Boolean,
      default: false
    }
  },

  mounted() {
    
  },

  updated() {
    if (this.valor.length === 1){
      this.mostrarItensNavegadores = false 
    } 
  },

  data() {
    return {
      popupFullScreen: false,
      numeroImagemFullScreen: 0
    };
  },

  methods: {
    // Função para abrir o popup FullScreen
    openModal (data) {
      let index = this.valor.findIndex((Element) => Element.id == data.item.id)
      this.numeroImagemFullScreen = index
      this.popupFullScreen = true
    }
  },

  computed: {},
};
